import PropTypes from 'prop-types';
import classNames from 'classnames';
import styles from './FJActivePanel.module.less';
const FJActivePanel = props => {
    const { active, children, className, style, isUnmount = false } = props;
    if (isUnmount && !active) {
        return null;
    }
    return (
        <div className={classNames(styles.container, active ? styles.show : styles.hide, className)} style={style}>
            {children}
        </div>
    );
};
FJActivePanel.propTypes = {
    active: PropTypes.bool.isRequired,
    children: PropTypes.node,
    className: PropTypes.string,
    style: PropTypes.object,
    isUnmount: PropTypes.bool,
};
export default FJActivePanel;
